import { Trophy, Star } from "lucide-react";

// Интерфейс для игрового уровня
export interface GameLevel {
  id: number;              // Уникальный идентификатор уровня
  name: string;            // Название уровня
  targetScore: number;     // Целевой счет для прохождения
  timeLimit?: number;      // Ограничение по времени (в секундах)
  heartSpawnRate: number;  // Частота появления сердечек (в миллисекундах)
  powerUpChance: number;   // Вероятность появления усилений (0-1)
  backgroundTheme: string; // CSS класс для темы фона
}

// Массив всех игровых уровней
export const GAME_LEVELS: GameLevel[] = [
  {
    id: 1,
    name: "Уровень 1",
    targetScore: 10,                              // Нужно собрать 10 сердечек
    heartSpawnRate: 2000,                         // Новое сердечко каждые 2 секунды
    powerUpChance: 0.1,                           // 10% шанс усиления
    backgroundTheme: "bg-gradient-background"     // Стандартный фон
  },
  {
    id: 2,
    name: "Уровень 2",
    targetScore: 20,                              // Нужно собрать 20 сердечек
    timeLimit: 60,                                // Ограничение 60 секунд
    heartSpawnRate: 1500,                         // Новое сердечко каждые 1.5 секунды
    powerUpChance: 0.15,                          // 15% шанс усиления
    backgroundTheme: "bg-gradient-romantic"       // Романтический фон
  },
  {
    id: 3,
    name: "Уровень 3",
    targetScore: 30,                              // Нужно собрать 30 сердечек
    timeLimit: 90,                                // Ограничение 90 секунд
    heartSpawnRate: 1000,                         // Новое сердечко каждую секунду
    powerUpChance: 0.2,                           // 20% шанс усиления
    backgroundTheme: "bg-gradient-heart"          // Сердечный фон
  }
];

// Интерфейс пропсов для отображения уровня
interface GameLevelDisplayProps {
  level: GameLevel;     // Текущий уровень
  score: number;        // Текущий счет
  timeLeft?: number;    // Оставшееся время (опционально)
}

// Компонент отображения информации об уровне
export const GameLevelDisplay = ({ level, score, timeLeft }: GameLevelDisplayProps) => {
  const progress = (score / level.targetScore) * 100;  // Прогресс в процентах

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-card rounded-lg p-4 shadow-lg z-10">
      <div className="text-center space-y-2">
        {/* Название уровня с иконкой трофея */}
        <div className="flex items-center justify-center space-x-2">
          <Trophy className="text-primary h-5 w-5" />
          <span className="font-bold text-lg">{level.name}</span>
        </div>
        
        {/* Счет и таймер */}
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-1">
            <Star className="text-accent h-4 w-4" />
            <span>{score} / {level.targetScore}</span>
          </div>
          
          {/* Отображение таймера, если есть ограничение по времени */}
          {timeLeft !== undefined && (
            <div className="text-sm">
              ⏰ {Math.max(0, Math.ceil(timeLeft))}s
            </div>
          )}
        </div>
        
        {/* Полоса прогресса */}
        <div className="w-48 bg-muted rounded-full h-2">
          <div 
            className="bg-gradient-heart h-2 rounded-full transition-all duration-300"
            style={{ width: `${Math.min(100, progress)}%` }}
          />
        </div>
      </div>
    </div>
  );
};